let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
import React from 'react';
import ReactDOM from 'react-dom';
import PackageBuilder from "../../react/order/PackageBuilder";

let main = function () {
    return Backbone.View.extend({
        initialize: function () {
        },

        onClose: function() {
            ReactDOM.unmountComponentAtNode(this.el);
            Backbone.View.prototype.remove.call(this);
            $('.orderFooter').removeClass('hidden');
        },

        render: function (props) {
            console.log("render react PackageBuilder with props ", props);
            ReactDOM.render(<PackageBuilder
                onConfirm={(selectedOptions) => {
                    props.onConfirm(selectedOptions);
                    this.onClose();

                }}
                onClose={() => {
                    this.onClose();
                }}
                packageSpec={props.package}
                price={props.price}/>, this.el);

            $('.orderFooter').addClass('hidden');
            return this;
        }
    });

};

export default main();


// WEBPACK FOOTER //
// ./src/view/order/PackageView.js